import { render } from "./MfittBookingResult.vue?vue&type=template&id=53f8ae64"
import script from "./MfittBookingResult.vue?vue&type=script&lang=js"
export * from "./MfittBookingResult.vue?vue&type=script&lang=js"
script.render = render

export default script